import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crave_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const rid = localStorage.getItem("crave_active_rid");
  if (rid) config.headers["X-Restaurant-Id"] = rid;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // don't auto-logout customer on menu fetches; pages handle it
    }
    return Promise.reject(err);
  }
);
